import styled, { css } from 'styled-components';

import { Link } from '@powdr/components';
import { Components, Breakpoints, ThemeProps as Prop } from '@powdr/constants';
import { componentColor } from '@powdr/utils';

const CPNT = Components.FOOTER_NAV;

export const StyledFooterNav = styled.div`
  min-height: 110px;
  width: 100%;
`;

export const LinkList = styled.ul`
  text-align: left;
`;

export const LinkItem = styled.li`
  display: block;
  line-height: 1.5;
`;

export const FooterLink = styled(Link)`
  font-size: ${({ theme }) => theme.FontSize.REG30};
  ${({ theme }) => theme.fonts.PRI_BDY_HVY};
  color: ${() => componentColor(Prop.LINK_TXT, CPNT)};
  transition: color 0.25s ease-out;

  &:hover, &:active, &:focus{
    transition: color 0.25s ease-out;
    color: ${() => componentColor(Prop.LINK_TXT_HOVER, CPNT)};
  }

  &:focus {
    outline: 2px solid ${() => componentColor(Prop.LINK_TXT_HOVER, CPNT)};
    outline-offset: 2px;
  }

  ${Breakpoints.large(css`
    font-size: ${({ theme }) => theme.FontSize.REG40};
  `)}

  ${Breakpoints.larger(css`
    font-size: ${({ theme }) => theme.FontSize.REG50} ;
  `)}
`;
